export default "__VITE_ASSET__DPvHFyk5__"